import { jsx as _jsx } from "react/jsx-runtime";
import Button from '@/components/atoms/Button/Button';
import { cn } from '@/helpers/cn';
import { focusFirstFocusableIn } from '@/helpers/focusUtils';
import { scrollTo } from '@/helpers/scrollTo';
import { applyTheme } from '@/utils/themeUtils';
export function SkipToMainContent({ label }) {
    const onClick = (event) => {
        event.preventDefault();
        window.requestAnimationFrame(() => {
            const targetComponent = document.querySelector('main');
            if (targetComponent) {
                focusFirstFocusableIn(targetComponent, () => scrollTo(targetComponent));
            }
        });
    };
    return (_jsx(Button, { variant: "solid", className: cn(applyTheme('light-a'), 'sr-only !absolute top-0 left-0 z-200 focus:not-sr-only'), children: (buttonProps) => (_jsx("button", { tabIndex: 0, onClick: onClick, "data-testid": "skip-to-main-content", ...buttonProps, children: label })) }));
}
